export default __webpack_public_path__ + "locales/es/JavascriptSdk.json?hash=1cc67888844b5162bc299b250bc40bc1";